import { sendWsMessage } from '../../../connection/create-ws-bridge.js';
import type WebSocket from 'ws';
import type { CliE2eeRuntime } from '../../../lib/e2ee/index.js';

export function sendSessionGitResult(
  ws: WebSocket | null,
  id: string,
  payload: Record<string, unknown>,
  e2ee?: CliE2eeRuntime,
  encryptedFields: readonly string[] = [],
): void {
  if (!ws) return;
  const message = { type: 'session_git_result', id, ...payload };
  let wire: Record<string, unknown> = message;
  if (e2ee && encryptedFields.length > 0) {
    wire = e2ee.encryptFields(message, encryptedFields);
  }
  sendWsMessage(ws, wire);
}
